import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperBlock = document.querySelectorAll(".logowall__gallery");

if (swiperBlock) {
    new Swiper(".logowall__gallery", {
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        spaceBetween: 80,
        slidesPerView: 8,
        pagination: {
            el: ".logowall-slider-pagination",
            clickable: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            460: {
                slidesPerView: 3,
                spaceBetween: 45,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 50,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 60,
            },
            1440: {
                slidesPerView: 8,
                spaceBetween: 80,
            },
        },
    });
}


